module.exports = __webpack_public_path__ + "img/image7.6e41230f.png";